module.exports = __webpack_public_path__ + "route.svg?1f2ba943742bd469e59abc8d1db503f0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/route.svg
// module id = 240
// module chunks = 0